import { defineClientModule, type ModuleRoute } from '@/app/module';
import { registerOfflinePrefetch } from '@/lib/query';
import { copy } from './copy';
import { ratingsQuery } from './queries';

/**
 * stats: the Stats tab (leaderboards, records, head to head, a player's numbers, the feed), the
 * Home feed card and a section on every profile. Ratings are prefetched for offline, because
 * matchmaking and Draft Night need them on a court with no signal.
 */
const routes: ModuleRoute[] = [
  { path: '/stats', screen: () => import('./screens/Leaders'), tab: 'stats' },
  { path: '/stats/records', screen: () => import('./screens/Records'), tab: 'stats' },
  { path: '/stats/h2h', screen: () => import('./screens/H2H'), tab: 'stats' },
  { path: '/stats/feed', screen: () => import('./screens/Feed'), tab: 'stats' },
  { path: '/stats/p/:id', screen: () => import('./screens/Player'), tab: 'stats' },
  { path: '/stats/*', screen: () => import('./screens/StatsMore'), tab: 'stats' },
];

export default defineClientModule({
  name: 'stats',
  routes,
  homeCards: [{ id: 'feed', order: 20, component: () => import('./parts/FeedCard') }],
  profileSections: [{ id: 'stats', order: 20, title: copy.title, component: () => import('./parts/ProfileStats') }],
  init() {
    registerOfflinePrefetch('stats.ratings', (qc) => qc.prefetchQuery(ratingsQuery()));
  },
});
